var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1305_152958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 26.3333L23 23M23 23L19.6667 26.3333M23 23V30.5M29.9917 28.325C30.8044 27.8819 31.4465 27.1807 31.8166 26.3322C32.1866 25.4836 32.2635 24.536 32.0352 23.6389C31.8068 22.7418 31.2862 21.9463 30.5556 21.3779C29.8249 20.8095 28.9257 20.5006 28 20.5H26.95C26.6978 19.5244 26.2276 18.6186 25.575 17.8508C24.9223 17.083 24.104 16.4732 23.1817 16.0672C22.2595 15.6611 21.2571 15.4695 20.2501 15.5066C19.2431 15.5437 18.2576 15.8086 17.3676 16.2814C16.4777 16.7542 15.7066 17.4226 15.1122 18.2363C14.5178 19.05 14.1156 19.9879 13.9358 20.9795C13.7561 21.971 13.8034 22.9904 14.0743 23.961C14.3453 24.9317 14.8327 25.8282 15.5 26.5833",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1305_152958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUploadIcon);
export default __webpack_public_path__ + "static/media/cloud-upload-icon.17ac9b4079ce289bb1d3372739d279d6.svg";
export { ForwardRef as ReactComponent };